import { Row, Col, Card } from '@everlywell/leaves';
import SectionWrapper from 'components/SectionWrapper';
import { GatsbyImage as Img } from 'gatsby-plugin-image';
import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import analytics from 'utils/analytics';
import { ANALYTICS } from 'utils/constants/analytics';

import { ContentWithImage, CTA } from '../../../utils/types';
import * as S from './styles';

export interface RecommendedArticlesSectionProps {
  title?: string;
  headline?: string;
  mainCta?: CTA;
  listOfContent?: ContentWithImage[];
}

export const RecommendedArticlesSection: React.FC<
  RecommendedArticlesSectionProps
> = ({ title, headline, mainCta, listOfContent }) => {
  const { inView, ref } = useInView({
    triggerOnce: true,
  });

  useEffect(() => {
    if (inView) {
      analytics.track({
        event: ANALYTICS.EVENTS.VIEWED_COMPONENT,
        data: {
          label: ANALYTICS.CATEGORY_PAGE.RECOMMENDED_ARTICLES,
        },
      });
    }
  }, [inView]);

  const handleArticleClick = (url: string) => () => {
    analytics.track({
      event: ANALYTICS.EVENTS.CLICKED_LINK,
      data: {
        label: ANALYTICS.CATEGORY_PAGE.RECOMMENDED_ARTICLES,
        url,
      },
    });
  };

  return (
    <>
      {listOfContent && (
        <SectionWrapper backgroundColor="Tertiary" ref={ref}>
          <S.SectionInner>
            {(title || headline) && (
              <S.Container>
                <Row>
                  <Col xs={12}>
                    {title && <S.Title>{title}</S.Title>}
                    {headline && <S.Headline>{headline}</S.Headline>}
                  </Col>
                </Row>
              </S.Container>
            )}
            <S.DesktopCardsContainer>
              {listOfContent.map((item, index) => (
                <S.CardWrapper key={index}>
                  <Card.Article
                    image={
                      <Img
                        image={item.image.gatsbyImageData}
                        style={{ width: '100%', height: '100%' }}
                        alt={item.heading}
                      />
                    }
                    imageAlt={`slide-${item}`}
                    title={item.heading}
                    copy={item.description?.description || ''}
                    url={item.cta?.url || ''}
                    linkText={item.cta?.text}
                    onClick={handleArticleClick(item.cta?.url || '')}
                  />
                </S.CardWrapper>
              ))}
            </S.DesktopCardsContainer>
            {mainCta && (
              <S.CtaContainer>
                <S.Button appearance="secondary" href={mainCta.url}>
                  {mainCta.text}
                </S.Button>
              </S.CtaContainer>
            )}
          </S.SectionInner>
        </SectionWrapper>
      )}
    </>
  );
};

export default RecommendedArticlesSection;
